import axiosInstance, { axiosMultipartFormDataInstance } from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';

const campaignService = {
    getAllCampaigns: (companyId) => { 
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}`);
    },

    createCampaign: (companyId, payload) => { 
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}`, payload);
    },

    deleteCampaign: (companyId, campaignId) => { 
        return axiosInstance.delete(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}`);
    },

    updateCampaign: (companyId, campaignId, payload) => { 
        return axiosInstance.put(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}`, payload);
    },

    deleteCampaigns: (companyId, payload) => {
        return axiosInstance.post(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${API_PATH.DELETE}`, payload);
    },

    uploadImage: (companyId, campaignId, payload) =>{
        return axiosMultipartFormDataInstance.post(
            `/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}/${API_PATH.IMAGE}`,
            payload
        );
    },

    deleteImage: (companyId, campaignId, imageId) => { 
        return axiosInstance.delete(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}/${API_PATH.IMAGE}/${imageId}`);
    },

    exportCampaign: (companyId, campaignId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}/${API_PATH.EXPORT}`) 
    },

    getCampaignDetails: (companyId, campaignId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CAMPAIGNS}/${campaignId}`) 
    },

    campaignIngestion: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.CAMPAIGN}/${API_PATH.INGESTION}/${companyId}`); 
    },

    updateCampaigningestion: (companyId, selected) => {
        return axiosInstance.put(`/${API_VERSION}/${API_PATH.CAMPAIGN}/${companyId}/${API_PATH.INGESTION}/${selected}`); 
    },

    selectedCampaignChannels: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.CHANNELS}/${API_PATH.SELECTED}`); 
    },

    selectedCampaignPartners: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.PARTNERS}/${API_PATH.SELECTED}`); 
    },

    campaignTriggers: (companyId) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANIES}/${companyId}/${API_PATH.TRIGGERS}`); 
    },
    
    updateCampaignGeneration: (companyId,selected) => 
    {
        return axiosInstance.put(`/${API_VERSION}/${API_PATH.CAMPAIGN}/${companyId}/${API_PATH.CAMPAIGN}/${selected}`)
    },
    
    updateCampaignDeduplication: (companyId, campaignId, deduplication) => 
    {
        return axiosInstance.put(`/${API_VERSION}/${API_PATH.CAMPAIGNS}/${campaignId}/${companyId}/${API_PATH.DEDUPLICATION}/${deduplication}`)
    }, 
    getCount : (companyId, campaignId ) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANY}/${companyId}/${API_PATH.CAMPAIGN}/${campaignId}/${API_PATH.PHYSICIAN}/${API_PATH.COUNT}`)
    },
    getCampaignSummary : (companyId, campaignId ) => {
        return axiosInstance.get(`/${API_VERSION}/${API_PATH.COMPANY}/${companyId}/${API_PATH.CAMPAIGN}/${campaignId}/${API_PATH.SUMMARY}`)
    },

}

export default campaignService;
